if (window.location.pathname === "/inyeccion/periodo") {

    const contGrafico = document.querySelector(".contGraficos");
    const contCanva = contGrafico.querySelector("#graficoReferencias");
    const params = new URLSearchParams(window.location.search);
    const mes = params.get("mes");
    const año = params.get("año");

    let graficoReferencias = null;

    const requestOptions = {
        method: "GET",
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        redirect: "follow",
    };

    window.actGraficoReferencias = (mes, año) => {

        const url = `/api/graficos/inyeccion/referencias?mes=${mes}&año=${año}`;

        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`Error HTTP: ${response.status}`);
                }

                return response.json();
            })
            .then((result) => {
                const data = result.result;
                const codigoSap = data.map(item => item.codigoSap);
                const cantidades = data.map(item => parseInt(item.undsBuenas));
                const colores = ['#74ab72','#071f5f', '#4f8df7', '#6b7280'];
                const clases = ['color1', 'color2', 'color3', 'color4'];

                const total = cantidades.reduce((sum, v) => sum + v, 0);

                if (graficoReferencias) {
                    graficoReferencias.destroy();
                }

                contCanva.classList.remove('skeletonGrafico');

                graficoReferencias = new Chart(contCanva, {
                    type: 'doughnut',
                    data: {
                        labels: codigoSap,
                        datasets: [{
                            data: cantidades,
                            backgroundColor: colores,
                            borderWidth: 0
                        }]
                    },
                    options: {
                        responsive: true,
                        cutout: '70%',
                        plugins: {
                            legend: {
                                display: false
                            }
                        }
                    }
                });

                const leyenda = contGrafico.querySelector('.leyendaDonut');
                leyenda.innerHTML = '';
                data.forEach((item, i) => {
                    const cant = parseInt(item.undsBuenas);
                    const pct = total > 0 ? ((cant / total) * 100).toFixed(1) : '0.0';
                    const cantFmt = cant.toLocaleString('es-CO');
                    const div = document.createElement('div');
                    div.id = `itemLeyenda${i + 1}`;
                    div.className = 'itemLeyenda';
                    div.innerHTML = `
                        <span class="punto ${clases[i] ?? ''}"></span>
                        <div>
                            <p>${item.DescripSap}</p>
                            <small>${cantFmt} (${pct}%)</small>
                        </div>`;
                    leyenda.appendChild(div);
                });

            })
            .catch((error) => {
                if (error.name === 'AbortError') return;
                console.error("Error gráfico referencias:", error);
            });
    };

    window.actGraficoReferencias(mes, año);

    setInterval(() => {
        window.actGraficoReferencias(mes, año);
    }, 120000);
}